const flexDirection = {
    row: 'row',
    rowReverse: 'row-reverse',
    column: 'column',
    columnReverse: 'column-reverse'
}

const basicAlignmnet = {
    start: 'start',
    end: 'end',
    left: 'left',
    right: 'right',
    flexStart: 'flex-start',
    flexEnd: 'flex-end',
    center: 'center',
}

const flexAlignItems = basicAlignmnet;
const flexJustifyContent = {
    ...basicAlignmnet,
    spaceBetween: 'space-between',
    spaceAround: 'space-around',
    spaceEvenly: 'space-evenly'
}

const flexAlignSelf = flexAlignItems;
const flexJustifySelf = flexJustifyContent;

const flexWrap = {
    noWrap: 'nowrap',
    wrap: 'wrap',
    wrapReverse: 'wrap-reverse'
}

export {
    flexDirection,
    flexAlignItems,
    flexJustifyContent,
    flexAlignSelf,
    flexJustifySelf,
    flexWrap
}